<template>
  <div id="contenedor-editar-contrato-insumo">
    <v-form v-model="formularioValido" ref="formEditarContratoInsumo">
      <v-card>
        <v-card-title class="secondary--text">
          Editar insumo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            cols="12"
            v-model="insumo.idInsumo"
            label="Insumo"
            :items="mixGetCatalogoInsumos"
            item-value="id"
            item-text="descripcion">
          </custom-select>
          <v-row>
            <!-- <custom-select
              cols="12"
              :md="$vuetify.breakpoint.mobile ? '12' : '6'"
              v-model="insumo.tipo"
              label="Tipo"
              :items="tiposInsumo">
            </custom-select> -->
            <text-field
              cols="12"
              :md="$vuetify.breakpoint.mobile ? '12' : '6'"
              v-model.number="insumo.cantidad"
              label="Cantidad"
              type="number"
            >
            </text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoInsumo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixInsumosContrato from './mixInsumosContrato';
import TextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'EditarContratoInsumo',
  mixins: [mixInsumosContrato],
  props: {
    contratoInsumoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextField,
    CustomButton,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tiposInsumo: [
        'SupExt',
        'Contratista',
      ],
      insumo: {
        idInsumo: this.contratoInsumoEditar.idInsumo,
        tipo: this.contratoInsumoEditar.tipo,
        cantidad: this.contratoInsumoEditar.cantidad,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.formEditarContratoInsumo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
